import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {Headers, Http} from "@angular/http";
import {Alert} from "../../../shared/alert/Alert";
import {AlertService} from "../../../shared/alert/alert.service";
import {Storyboard} from "storyboard-renderer";
import {TranslationLanguage} from "./TranslationLanguage";

@Injectable()
export class TranslateService {

  private endpoint = environment.apiBaseUrl + '/api/v1.0/';
  private headers = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: Http, private alertService: AlertService) {

  }

  getLanguages(storyboard: Storyboard): Promise<TranslationLanguage[]> {
    console.log("yoloka");
    const url = this.endpoint + 'user/' + storyboard.user.id + '/storyboard/' + storyboard.id + "/translation_language";

    return this.http
      .get(url, {headers: this.headers})
      .toPromise()
      .then(response => TranslationLanguage.fromJsonArray(response.json()))
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    this.alertService.danger(new Alert('Something went wrong, please try again later.'));
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/shared/translate.service.ts